import { useTranslation } from 'react-i18next';
import { Config } from '../../utils';

export const usePaxSummaryText = (pax, numberRooms) => {
    const { t } = useTranslation();
    const direction = Config.get('isRtl') ? 'rtl' : 'ltr';
    const labelRooms = t('dynpack.searchSummary.rooms', { count: numberRooms });
    const labelAdults = t('paxSelector.adult.text', { count: pax.adults });
    const labelKids =
        pax.kids > 0
            ? `${t('paxSelector.separator')} ${t('paxSelector.child.text', { count: pax.kids })}`
            : '';
    let paxSummaryText;
    if (direction === 'rtl') {
        paxSummaryText = `${labelKids ? labelKids + ' ' : ''}${labelAdults} ,${labelRooms}`;
    } else {
        paxSummaryText = `${labelRooms}, ${labelAdults}${labelKids ? ' ' + labelKids : ''}`;
    }

    return [paxSummaryText];
};
